module.exports = __webpack_public_path__ + "static/valor-digital-solutions-our-mission-3686e6fa5943fc15e7e9fa2128eaed6b.jpg";